import { render } from "./SingleCourseFilter.vue?vue&type=template&id=b9410c36&scoped=true"
import script from "./SingleCourseFilter.vue?vue&type=script&lang=js"
export * from "./SingleCourseFilter.vue?vue&type=script&lang=js"

import "./SingleCourseFilter.vue?vue&type=style&index=0&id=b9410c36&scoped=true&lang=scss"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9410c36"]])

export default __exports__